module.exports = __webpack_public_path__ + "media/images/success/2-6416493011f4900fea8a7fe9cbb8c63d.png";